// extracted by mini-css-extract-plugin
export default {"knowledgeRoot":"Knowledge_knowledgeRoot__Jdi5A"};